import React from "react";

// Styles
import "./../styles/Home.css";

// Image
import finance from "./../assets/Finance.png";

const Home = () => {
  return (
    <>
      <div id="scrollspyhome" className="container-fluid pt-3">
        <div className="row d-flex align-items-center bg-secondary bg-opacity-10 mt-4 py-5">
          <div className="col-md-6 d-block text-start ps-5">
            <div className="d-block text-start">
              <p className="text-secondary fs-1">
                Manage Your <br /> Finances Using <br />{" "}
                <span className="textColor">PesoPulse</span>
              </p>
              <p>Your very own accounting solution for everyday use.</p>
              <a href="https://pesopulse.com/register">
              <button className="btn customButton">Register!!</button>
              </a>
            </div>
          </div>
          <div className="col-md-6">
            <img className="img-fluid imageSize" src={finance} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
